import { IStore } from '../../../common/store';

const variantSpecificationsSelectors = {
  getVariantErrorState: (state: IStore) => state.customiseCombinedReducer.variantSpecificationsReducer.error,
  getLoadingStatus: (state: IStore) => state.customiseCombinedReducer.variantSpecificationsReducer.loading,
  getStandardFeatures: (state: IStore) =>
    state.customiseCombinedReducer.variantSpecificationsReducer.variantSpecifications?.standardFeatures,
  getTechnicalSpecifications: (state: IStore) =>
    state.customiseCombinedReducer.variantSpecificationsReducer.variantSpecifications?.technicalSpecifications,
  getCurrentSpecificationsVariantId: (state: IStore) =>
    state.customiseCombinedReducer.variantSpecificationsReducer.currentSpecificationsVariantId,
};

export default variantSpecificationsSelectors;
